module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("\n    BTC past month (or since BCH hf if hf < 30 days)\n  ")]), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n    In the period from " + _vm._s(_vm.date_from) + " to " + _vm._s(_vm.date_to) + " a total number of " + _vm._s(_vm.blocks) + " blocks were mined.\n    This results in an average of "), _c('u', [_vm._v(_vm._s(_vm.blocktime) + " minutes")]), _vm._v("\n    to find a block.\n  ")]), _vm._v(" "), _c('p', [_c('small', [_vm._v("\n      Average number of blocks per hour over the entire period (measured over " + _vm._s(_vm.interval / 60) + " minute intervals):\n      "), _c('table', {
    staticClass: "table table-sm table-bordered times-table"
  }, [_vm._m(1, false, false), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "noc"
  }, [_vm._v("Blocks:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.times['15']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.times['10']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.times['7']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.times['5']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.times['3']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.times['2']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.times['1']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.times['0']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "noc"
  }, [_vm._v("Percentage:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.times_pct('15')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.times_pct('10')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.times_pct('7')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.times_pct('5')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.times_pct('3')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.times_pct('2')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.times_pct('1')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.times_pct('0')))])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', {
    staticClass: "times-high",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.block_times_high) + "\n          ")]), _vm._v(" "), _c('td', {
    staticClass: "times-norm"
  }, [_vm._v("\n            " + _vm._s(_vm.block_times_norm) + "\n          ")]), _vm._v(" "), _c('td', {
    staticClass: "times-low",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.block_times_low) + "\n          ")])])])])]), _vm._v(" "), _c('small', [_vm._v("\n      Number of blocks mined during periods of relative block reward per amount of work done compared to BCH.\n      "), _c('table', {
    staticClass: "table table-sm table-bordered times-table"
  }, [_vm._m(2, false, false), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "noc"
  }, [_vm._v("Blocks:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.blocks_dari.vlow))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.blocks_dari.low))]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.blocks_dari.norm))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.blocks_dari.high))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.blocks_dari.vhigh))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "noc"
  }, [_vm._v("Percentage:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dari_pct('vlow')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dari_pct('low')))]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.dari_pct('norm')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dari_pct('high')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dari_pct('vhigh')))])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', {
    staticClass: "times-high",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.sprintf('%.2f%%', _vm.dari_low / _vm.blocks * 100)))]), _vm._v(" "), _c('td', {
    staticClass: "times-norm",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.sprintf('%.2f%%', _vm.dari_high / _vm.blocks * 100)))])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "512px",
      "width": "100%"
    }
  }, [_c('canvas', {
    staticStyle: {
      "height": "512px"
    },
    attrs: {
      "id": "canvas-daa"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "thead-dark chead"
  }, [_c('tr', [_c('th', {
    staticClass: "noc"
  }, [_vm._v("Blocks/hr:")]), _vm._v(" "), _c('th', [_vm._v("15+")]), _vm._v(" "), _c('th', [_vm._v(">10-15")]), _vm._v(" "), _c('th', [_vm._v(">8-10")]), _vm._v(" "), _c('th', [_vm._v(">4-8")]), _vm._v(" "), _c('th', [_vm._v(">3-4")]), _vm._v(" "), _c('th', [_vm._v(">2-3")]), _vm._v(" "), _c('th', [_vm._v(">1-2")]), _vm._v(" "), _c('th', [_vm._v("<1")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "thead-dark chead"
  }, [_c('tr', [_c('th', {
    staticClass: "noc"
  }, [_vm._v("DARI ratio:")]), _vm._v(" "), _c('th', [_vm._v("< 0.7x")]), _vm._v(" "), _c('th', [_vm._v("0.7x - 0.9x")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("0.9x - 1.1x")]), _vm._v(" "), _c('th', [_vm._v("1.1x - 1.30x")]), _vm._v(" "), _c('th', [_vm._v("> 1.30x")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bf28d0f0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/charts/coin/btc.vue
// module id = 560
// module chunks = 1